type Envs = "local" | "dev" | "test" | "demo" | "prod";

interface IEnvConfig {
    authUrl: string;
    apiUrl: string;
    clarityProjectId?: string;
}

const ENV_CONFIGS: Record<Envs, IEnvConfig> = {
    local: {
        authUrl: import.meta.env.VITE_AUTH_BASE,
        apiUrl: import.meta.env.VITE_API_BASE,
    },
    dev: {
        authUrl: import.meta.env.VITE_AUTH_BASE || "https://auth.dev.qa.dbg.com",
        apiUrl: import.meta.env.VITE_API_BASE || "https://api.dev.qa.dbg.com/value",
        clarityProjectId: "t55s1rulq6",
    },
    test: {
        authUrl: import.meta.env.VITE_AUTH_BASE || "https://auth.test.qa.dbg.com",
        apiUrl: import.meta.env.VITE_API_BASE || "https://api.test.qa.dbg.com/value",
    },
    demo: {
        authUrl: import.meta.env.VITE_AUTH_BASE || "https://auth.demo.dbg.com",
        apiUrl: import.meta.env.VITE_API_BASE || "https://api.demo.dbg.com/value",
        clarityProjectId: "t4vrgj5cpf",
    },
    prod: {
        authUrl: import.meta.env.VITE_AUTH_BASE || "https://auth.dbg.com",
        apiUrl: import.meta.env.VITE_API_BASE || "https://api.dbg.com/value",
        clarityProjectId: "t56dmc50cn",
    },
};

// Function to determine the environment based on the hostname
export function getEnv(): Envs {
    const hostname = window.location.hostname;

    let env: Envs;
    if (hostname.includes("localhost")) {
        env = "local";
    } else if (hostname.includes("dev")) {
        env = "dev";
    } else if (hostname.includes("test")) {
        env = "test";
    } else if (hostname.includes("demo")) {
        env = "demo";
    } else {
        env = "prod";
    }

    return env;
}

function getConfig() {
    return ENV_CONFIGS[getEnv()];
}

export const config = {

    get authHost() {
        return getConfig().authUrl;
    },

    get apiHost() {
        return getConfig().apiUrl;
    },

    get clarityProjectId() {
        return getConfig().clarityProjectId;
    }
}
